export type ProjectCaseStudy = {
  slug: string;
  title: string;
  shortTitle: string;
  description: string;
  client: string;
  sector: string;
  image: string;
  externalUrl: string;
  services: string[];
  outcomes: string[];
  summary: string[];
  challenge: string;
  approach: string[];
  result: string[];
};

export const projects: ProjectCaseStudy[] = [
  {
    slug: "sentinel-door-systems",
    title: "Sentinel Door Systems website rebuild",
    shortTitle: "Sentinel Door Systems",
    description:
      "A clearer industrial door website structure for products, emergency support, maintenance, and nationwide enquiries.",
    client: "Sentinel Door Systems",
    sector: "Industrial doors and engineering services",
    image: "/images/brand/sentinel-door-systems-new-website-1200.webp",
    externalUrl: "https://sentineldoors.co.uk/",
    services: ["Web design", "Technical SEO", "Content structure", "Local SEO"],
    outcomes: [
      "Separated product, installation, maintenance, and emergency support journeys.",
      "Improved routes for quote requests, repair enquiries, and product research.",
      "Built a clearer structure for regional visibility and national service positioning.",
    ],
    summary: [
      "Sentinel needed a website that made a broad technical product range easier to understand.",
      "The rebuild organised product pages, service routes, emergency support, and location content around customer intent.",
    ],
    challenge:
      "Industrial door buyers may arrive with a specific product in mind, or with an urgent repair need and little technical detail. The site needed to support both journeys without making visitors work through one generic menu.",
    approach: [
      "Reworked navigation around products, installation, maintenance, repairs, and emergency support.",
      "Placed phone and quote actions close to high-intent service content.",
      "Connected Barnsley manufacturing credibility with wider UK service coverage.",
    ],
    result: [
      "The finished site gives Sentinel a stronger sales reference and a clearer search structure.",
      "Customers can move from a product, service need, or location page towards the right enquiry route faster.",
    ],
  },
  {
    slug: "oracle-training-consultants",
    title: "Oracle Training Consultants website rebuild",
    shortTitle: "Oracle Training Consultants",
    description:
      "A WordPress and WooCommerce rebuild for course discovery, learner support, employer information, and online short-course booking.",
    client: "Oracle Training Consultants",
    sector: "Training provider",
    image: "/images/brand/oracle-training-consultants-new-website-1200.webp",
    externalUrl: "https://oracle-uk.com/",
    services: ["WordPress", "WooCommerce", "Web design", "Technical SEO"],
    outcomes: [
      "Separated learner, parent, employer, and short-course customer journeys.",
      "Added online short-course booking with payment options including Klarna.",
      "Gave the team a clearer editing structure for course dates, news, and guidance.",
    ],
    summary: [
      "Oracle needed a modern website for several audiences with different questions and next steps.",
      "The rebuild joined course content, learner support, employer services, and ecommerce booking into one manageable structure.",
    ],
    challenge:
      "A prospective apprentice, parent, employer, and commercial course customer all need different information. The old structure made those routes harder to separate and update.",
    approach: [
      "Rebuilt the page hierarchy around real audience groups and course discovery tasks.",
      "Used WooCommerce for short-course booking and payment flows.",
      "Improved headings, metadata, and internal links so course types and support content were easier to understand.",
    ],
    result: [
      "The finished site is easier for visitors to navigate and easier for the Oracle team to manage.",
      "Client feedback confirmed the site is now generating enquiries and gives the business a website they are proud to share.",
    ],
  },
];

export function getProject(slug: string) {
  return projects.find((project) => project.slug === slug);
}
